import CollectionProductCard from '@/scripts/components/CollectionProductCard';

const SELECTOR = '[data-collection-product-card]';

function ready(fn) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn, {once: true});
    } else {
        fn();
    }
}

function init() {
    document.querySelectorAll(SELECTOR).forEach((root) => {
        if (root.dataset.cpcReady) {
            return;
        }

        root.dataset.cpcReady = 'true';
        root.collectionProductCard = new CollectionProductCard(root);
    });
}

function teardown(event) {
    event.target.querySelectorAll(SELECTOR).forEach((root) => {
        if (root.collectionProductCard) {
            root.collectionProductCard.destroy();
            delete root.collectionProductCard;
        }

        delete root.dataset.cpcReady;
    });
}

ready(init);

document.addEventListener('shopify:section:load', init);
document.addEventListener('shopify:section:unload', teardown);
